///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ClogIcon = ({
  height,
  fill = "#FFFFFF",
  title = messages.clog.defaultMessage,
  width,
  secondaryColor = "#27D434",
  ...rest
}) => (
  <svg
    aria-labelledby="clog-icon"
    width={width}
    height={height}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    {...rest}
  >
    <title id="clog-icon">{title}</title>
    <defs>
      <path
        d="M19 13a8 8 0 000-2l3-2-2-4h-1l-2 1-2-1-1-3h-4L9 5 7 6 5 5H4L2 9l3 2a8 8 0 000 2l-3 2 2 4h1l2-1 2 1 1 3h4l1-3 2-1 2 1h1l2-4-3-2zm-7 3a4 4 0 110-8 4 4 0 010 8z"
        id="clog-icon-path"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle fill={secondaryColor} cx="18" cy="18" r="18" />
      <g transform="translate(6 6)">
        <path d="M0 0h24v24H0z" />
        <mask id="clog-icon-mask" fill={fill}>
          <use xlinkHref="#clog-icon-path" />
        </mask>
        <use fill="#000" xlinkHref="#clog-icon-path" />
        <g mask="url(#clog-icon-mask)" fill={fill}>
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </g>
  </svg>
);

export default ClogIcon;
